export default {
  'user.title': 'Konto',
  'user.persona': 'Angaben zur Person',
  'user.name': 'Name',
  'user.birthday': 'Geburtsdatum',
  'user.password': 'Passwort',
  'user.password.description': 'Passwort ändern',
  'user.email': 'E-Mail',
  'user.phone': 'Telefonnummer',
  'user.contact': 'Kontakt',

  'user.verification': 'E-Mail Bestätigung',
  'user.verified': 'E-Mail wurde bestätigt',
  'user.not-verified':
    'E-Mail Bestätigung ausstehend. Klicken Sie hier, um die E-Mail erneut zu senden.',
  'user.not-verified.resent':
    'Verifizierungs E-Mail wurde versendet. Erneute E-Mail Zustellung ist nicht mehr möglich.',

  'change-password': 'Passwort ändern',
  'change-password.success': 'Passwort wurde erfolgreich geändert',
  'change-password.success.description': 'Bitte melden Sie sich erneut an',
  'change-password.old-password': 'Altes Passwort',
  'change-password.new-password': 'Neues Passwort',
  'change-password.new-password.repeat': 'Neues Passwort wiederholen',
  'change-password.required-field': 'Bitte füllen Sie alle angegebenen Felder aus',

  'account-details': 'Kontoinformationen',

  'set-new-password': 'Neues Passwort setzen',
  'set-new-password.description': 'Bitte geben Sie Ihr neues Passwort zweimal ein.',

  // Reset password
  'reset-password.sent': 'Bitte überprüfen Sie Ihr Postfach',
  'reset-password.success': 'Passwort wurde zurückgesetzt',
  'reset-password.sent.description':
    'Falls bereits ein Account mit der eingegebenen E-Mail-Adresse existiert, wird Ihnen ein Link zum Zurücksetzen des Passworts an diese Adresse geschickt.',
  'reset-password': 'Passwort zurücksetzen',
  'reset-password.error':
    'Ihr Passwort konnte nicht zurückgesetzt werden. Bitte überprüfen Sie die eingegebene E-Mail Adresse.',
  'prepare-password-reset.title': 'Passwort zurücksetzen',
  'prepare-password-reset.error':
    'Ihr Passwort konnte nicht zurückgesetzt werden. Bitte überprüfen Sie die eingegebene E-Mail Adresse.',
  'prepare-password-reset.description':
    'Bitte geben Sie die E-Mail Adresse an, mit der Sie das Konto erstellt haben. Sie werden eine E-Mail mit einem Link zum Zurücksetzen bekommen.',
};
